import {useQuery} from "@tanstack/react-query";
import {getCreditBalance, getCreditTransactions} from "../../api/api";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import RecordsNotFound from "../../components/RecordsNotFound";
import Paginator from "../../components/Paginator";
import Loader from "../../components/Loader";

function CreditTransactionsTab() {
    const {refreshToken} = useContext(AuthContext)
    const [page, setPage] = useState(1);

    const [queryKey, setQueryKey] = useState(['credit-transaction', page])

    useEffect(() => {
        setQueryKey(['credit-transaction', page])
    }, [page]);

    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getCreditTransactions(page),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }),
    })

    const { status:statusCreditBalance, data:dataCreditBalance, error:errorCreditBalance, refetch:refetchCreditBalance } = useQuery({
        queryKey: ['credit-balance'],
        queryFn: () => getCreditBalance(),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetchCreditBalance)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }),
    })


    return (
        <>
            <div className="text-center mb-2">
                <div className="row">
                    <div className="col-12">
                        <div className="card-box border">
                            <i className="fe-credit-card font-24"/>
                            {statusCreditBalance === 'loading' && (
                                <Loader size={'default'}/>
                            )}
                            {statusCreditBalance === 'success' | errorCreditBalance?.response?.status === 401 && (
                                <h3 className="text-success">{dataCreditBalance.results[0].points}</h3>
                            )}
                            <p className="text-uppercase mb-1 font-13 font-weight-medium">Credit Points Balance</p>
                        </div>
                    </div>

                </div>
            </div>
            {status === 'success' | error?.response?.status === 401 && (
                <div className="table-responsive">
                    <table className="table table-centered mb-0">
                        <thead className="font-13 bg-light text-muted">
                            <tr>
                                <th>Transactions ID</th>
                                <th>Name</th>
                                <th>Points</th>
                                <th>Type</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                    <tbody>
                    {data?.count > 0? data?.results?.map(txn => (
                        <tr key={txn.id}>
                            <td>
                                {txn.id} <span
                                onClick={() => {navigator.clipboard.writeText(txn.id)}}
                                className="mdi mdi-content-copy"/>
                            </td>
                            <th>{txn.name}</th>
                            <th>{txn.points}</th>
                            <th>{txn.type==='CR'?<span className="badge bg-success">{txn.type}</span>: <span className="badge bg-danger">{txn.type}</span>}
                            </th>
                            <td>
                                {txn.created}
                            </td>
                        </tr>
                    )): <RecordsNotFound/>}
                    </tbody>
                    </table>
                    {status === 'success' && (
                        <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                    )}
                </div>
            )}

        </>
    );
}

export default CreditTransactionsTab;